const FORM_STATE_KEYS = ['careerLevel', 'urgency', 'services', 'features', 'useBalance'];

function getUrl() {
    if (typeof window === 'undefined') return null;
    return new URL(window.location.href);
}

function replaceUrl(url) {
    if (!url || typeof window === 'undefined') return;
    window.history.replaceState({}, '', url.toString());
}

function readList(searchParams, key) {
    const repeated = searchParams.getAll(key).filter(Boolean);
    const values = repeated.length > 1 ? repeated : (repeated[0] || '')
        .split(',')
    ;

    return (Array.isArray(values) ? values : [values])
        .flatMap(value => String(value).split(','))
        .map(value => value.trim())
        .filter(Boolean);
}

function writeList(searchParams, key, values) {
    const list = Array.isArray(values) ? values.filter(Boolean) : [];
    searchParams.delete(key);
    list.forEach(value => searchParams.append(key, value));
}

export function readCouponFromUrl() {
    try {
        return new URLSearchParams(window.location.search).get('coupon')?.trim() || '';
    } catch {
        return '';
    }
}

export function writeCouponToUrl(code) {
    const url = getUrl();
    if (!url || !code) return;

    url.searchParams.set('coupon', code);
    replaceUrl(url);
}

export function clearCouponFromUrl() {
    const url = getUrl();
    if (!url) return;

    url.searchParams.delete('coupon');
    replaceUrl(url);
}

export function readResumeFormStateFromUrl() {
    try {
        const params = new URLSearchParams(window.location.search);

        return {
            careerLevel: params.get('careerLevel') || '',
            urgency: params.get('urgency') || '',
            services: readList(params, 'services'),
            features: readList(params, 'features'),
            useBalance: params.get('useBalance') === '1',
        };
    } catch {
        return {};
    }
}

export function normalizeResumeFormUrlState(urlState = {}, options = {}) {
    const hasOwn = (items, key) => !!key && !!items && Object.prototype.hasOwnProperty.call(items, key);
    const filterExisting = (values, items) => Array.isArray(values)
        ? values.filter(value => hasOwn(items, value))
        : [];

    return {
        careerLevel: hasOwn(options.careerLevel, urlState.careerLevel) ? urlState.careerLevel : '',
        urgency: hasOwn(options.urgency, urlState.urgency) ? urlState.urgency : '',
        services: filterExisting(urlState.services, options.service),
        features: filterExisting(urlState.features, options.features),
        useBalance: urlState.useBalance === true,
    };
}

export function writeResumeFormStateToUrl(values = {}) {
    const url = getUrl();
    if (!url) return;

    const params = url.searchParams;
    const next = {
        careerLevel: values.careerLevel || '',
        urgency: values.urgency || '',
        services: values.services || [],
        features: values.features || [],
        useBalance: values.useBalance ? '1' : '',
    };

    if (next.careerLevel) {
        params.set('careerLevel', next.careerLevel);
    } else {
        params.delete('careerLevel');
    }

    if (next.urgency) {
        params.set('urgency', next.urgency);
    } else {
        params.delete('urgency');
    }

    writeList(params, 'services', next.services);
    writeList(params, 'features', next.features);

    if (next.useBalance) {
        params.set('useBalance', next.useBalance);
    } else {
        params.delete('useBalance');
    }

    replaceUrl(url);
}

export function clearResumeFormStateFromUrl() {
    const url = getUrl();
    if (!url) return;

    FORM_STATE_KEYS.forEach(key => url.searchParams.delete(key));
    replaceUrl(url);
}
